import { ChangeDetectionStrategy, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { combineLatest } from 'rxjs';
import { filter, first, map, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';

import { cardF } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LrcFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => LrcFormComponent),
    },
  ],
  selector: 'app-lrc-form',
  styleUrls: ['./lrc-form.component.scss'],
  templateUrl: './lrc-form.component.html',
})
export class LrcFormComponent extends BaseCtrlValueAccessorFormComponent<cardF.LRC> implements OnDestroy, OnInit {
  constructor(
  ) {
    super();

    this.formChange.pipe(
      first((form): form is UntypedFormGroup => !!form),
      switchMap((form) => combineLatest([
        this.formChange,
        form.valueChanges.pipe(startWith(undefined)),
      ]).pipe(
        map(([f]) => f),
        filter((f): f is UntypedFormGroup => !!f),
        takeUntil(this.unsubscription$),
      )),
      filter((form): form is UntypedFormGroup => !!form),
      takeUntil(this.unsubscription$),
    ).subscribe((form) => {
      if (form.controls.LRCS.value === undefined) {
        form.controls.LRCR.disable({ emitEvent: false });
      } else {
        form.controls.LRCR.enable({ emitEvent: false });
      }

      if (form.controls.LRCR.value === undefined) {
        form.controls.LRCP.disable({ emitEvent: false });
      } else {
        form.controls.LRCP.enable({ emitEvent: false });
      }

      if (form.controls.LRCP.value === undefined) {
        form.controls.LRCC.disable({ emitEvent: false });
      } else {
        form.controls.LRCC.enable({ emitEvent: false });
      }
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
